// @flow
import { OtherDataContactsActionTypes } from './constants';

const INIT_STATE = {
    otherDataContact: {},
    listaOtherDataContacts: [],
    loading: false,
    error: false,
    formSubmited: false
};

type OtherDataContactsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { otherDataContact?: {} | null, listaOtherDataContacts?: [] | null, loading?: boolean, +value ?: boolean };

const OtherDataContacts = (state: State = INIT_STATE, action: OtherDataContactsAction): any => {
    // console.log(action);
    switch (action.type) {
        case OtherDataContactsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case OtherDataContactsActionTypes.GET_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        otherDataContact: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OtherDataContactsActionTypes.LIST_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        listaOtherDataContacts: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OtherDataContactsActionTypes.ADD_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case OtherDataContactsActionTypes.UPDATE_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case OtherDataContactsActionTypes.DELETE_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OtherDataContactsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case OtherDataContactsActionTypes.GET_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        otherDataContact: {},
                        loading: false,
                    };
                }
                case OtherDataContactsActionTypes.LIST_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaOtherDataContacts: [],
                        loading: false,
                    };
                }
                case OtherDataContactsActionTypes.ADD_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case OtherDataContactsActionTypes.UPDATE_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case OtherDataContactsActionTypes.DELETE_OTHER_DATA_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OtherDataContactsActionTypes.GET_OTHER_DATA_CONTACTS:
            return { ...state, error: false, loading: true };
        case OtherDataContactsActionTypes.LIST_OTHER_DATA_CONTACTS:
            return { ...state, error: false, loading: true };
        case OtherDataContactsActionTypes.ADD_OTHER_DATA_CONTACTS:
            return { ...state, error: false, loading: true };
        case OtherDataContactsActionTypes.UPDATE_OTHER_DATA_CONTACTS:
            return { ...state, error: false, loading: true };
        case OtherDataContactsActionTypes.DELETE_OTHER_DATA_CONTACTS:
            return { ...state, error: false, loading: true };
        case OtherDataContactsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                otherDataContact: {},
                listaOtherDataContacts: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default OtherDataContacts;
